"use client";

import { c as _c } from "react/compiler-runtime";
import { Phone, PhoneOff } from "lucide-react";
import { useCall } from "../model/use-call";
import { useCallStore } from "../model/call-store";

/**
 * Incoming-call prompt. Rendered by CallBridge; visible only while `phase` is
 * `incoming`. Minimal by design — needs a ui-ux-designer polish pass before
 * release (avatar, ringtone, caller name resolution).
 */
export function IncomingCallModal() {
  const $ = _c(26);
  const phase = useCallStore(_temp);
  const incoming = useCallStore(_temp2);
  const {
    answer,
    decline
  } = useCall();
  if (phase !== "incoming") {
    return null;
  }
  const isInvite = incoming?.mode === "invite";
  let t0;
  if ($[0] !== decline || $[1] !== isInvite) {
    t0 = isInvite ? _temp3 : () => void decline();
    $[0] = decline;
    $[1] = isInvite;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onDismiss = t0;
  const t1 = isInvite ? "Call invite" : "Incoming call";
  const t2 = isInvite ? "You're being added to a call" : "Incoming audio call";
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="text-sm font-semibold text-[#091E42] dark:text-gray-100">{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = isInvite ? "Tap to join" : "Tap to answer";
  let t5;
  if ($[5] !== t4) {
    t5 = <span className="text-xs text-[#44546F] dark:text-gray-400">{t4}</span>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <div className="flex flex-col">{t3}{t5}</div>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== answer) {
    t7 = () => void answer();
    $[10] = answer;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Phone className="h-5 w-5" />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7) {
    t9 = <button type="button" onClick={t7} aria-label="Answer" className="flex h-11 w-11 items-center justify-center rounded-full bg-green-600 text-white transition-colors hover:bg-green-700 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-green-500/50">{t8}</button>;
    $[13] = t7;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = isInvite ? "Dismiss" : "Decline";
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <PhoneOff className="h-5 w-5" />;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== onDismiss || $[17] !== t10) {
    t12 = <button type="button" onClick={onDismiss} aria-label={t10} className="flex h-11 w-11 items-center justify-center rounded-full bg-red-600 text-white transition-colors hover:bg-red-700 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-red-500/50">{t11}</button>;
    $[16] = onDismiss;
    $[17] = t10;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t6 || $[21] !== t9) {
    t13 = <div className="flex items-center gap-4 rounded-2xl bg-white px-5 py-4 shadow-2xl ring-1 ring-black/10 dark:bg-[#0b1020] dark:ring-white/10">{t6}{t9}{t12}</div>;
    $[19] = t12;
    $[20] = t6;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t1 || $[24] !== t13) {
    t14 = <div data-testid="chat-incoming-call" className="fixed inset-x-0 top-6 z-100 flex justify-center px-4" role="dialog" aria-label={t1}>{t13}</div>;
    $[23] = t1;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
}
function _temp3() {
  return useCallStore.getState().reset();
}
function _temp2(s_0) {
  return s_0.incoming;
}
function _temp(s) {
  return s.phase;
}